export const DELIMITER = ':';

export const RECENT_ORDERS_TYPENAME = 'RecentOrderHistory';
export const BUY_IT_AGAIN_SCHEMA_NAME = 'cust_reorder';
export const RECENTLY_VIEWED_SCHEMA_NAME = 'rv_homepage_rr';
const RECENT_ORDERS_MAX_AGE = 1000 * 60 * 60 * 24 * 760; // 25 months
const RECENTLY_VIEWED_MAX_AGE = 1000 * 60 * 60 * 24 * 14; // 2 weeks; TODO; not sure if this is the time frame we want

function GOOD_IF_NEWER_FUNC(maxAge, ts) {
  return Date.now() - maxAge <= +ts;
}

export const SM_FUNCS = {
  [RECENT_ORDERS_TYPENAME]: (ts) => GOOD_IF_NEWER_FUNC(RECENT_ORDERS_MAX_AGE, ts),
  [BUY_IT_AGAIN_SCHEMA_NAME]: (ts) => GOOD_IF_NEWER_FUNC(RECENT_ORDERS_MAX_AGE, ts),
  [RECENTLY_VIEWED_SCHEMA_NAME]: (ts) => GOOD_IF_NEWER_FUNC(RECENTLY_VIEWED_MAX_AGE, ts),
};

export const CHANNEL_OPTIONS = ['minWidthLarge', 'minWidthMedium'];
export const DEFAULT_OPERATIONS = [
  'placeLockedComponentsInGrid',
  'fillInOrphanedComponents', // leaving this out means always a grid, but not all orphans from unlocked are rendered
  'placeUnlockedComponentsInGrid',
  'fillInOrphanedComponents', // leaving this out means always a grid, but not all orphans from unlocked are rendered
  'expandRows',
];
